import React, { useState, useEffect } from 'react'
import "../Styles/Wg_Dashboard.css"
import axios from "axios";
import { GiSewingMachine } from "react-icons/gi";

import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { CountdownCircleTimer } from 'react-countdown-circle-timer'

function Wg_Dashboard() {

  const [arrangement, setArrangement] = useState({})

  const dashboardApi = async () => {
    try {
      let url = process.env.REACT_APP_BASE_URL + "/wg/wgDashboard";
      let body = {
        comp_num: "260",
        wg_num: "1"
      };
      console.log("body login", body);
      await axios
        .post(url, body, {
          // headers: {
          //   authorization: `${userDetails.access_token}`,
          // },
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.statusCode === 0) {
              console.log("dashboardApi", response.data);
              setArrangement(response.data)
            }
            else {
              console.log("dashboardApi", response.data.msg);
            }
          }
        })
        .catch((error) => {
          console.log("dashboardApi", error);
          dashboardApi()
        });
    } catch (error) {
      console.log("dashboardApi", error);
      dashboardApi()
    }
  }

  var chunkedArrangement = [];

  if (Object.keys(arrangement).length !== 0) {

    if (arrangement.machine_list.length < 7) {
      chunkedArrangement = arrangement.machine_list;
    }
    else {
      for (let i = 0; i < arrangement.machine_list.length; i += 10) {
        chunkedArrangement.push(arrangement.machine_list.slice(i, i + 10));
      }
    }
  }



  useEffect(() => {
    dashboardApi();
  }, []);

  const onTimerComplete = () => {
    console.log("Timer completed!");
    dashboardApi();
  };



  return (
    <div>
      <div style={{
        backgroundColor: '#f8f9fa',
        borderBottom: "2px solid #e0e0e0", display: 'inline-flex', width: "100%", alignItems: 'center',
      }}>
        <h2 className="header-h2" style={{ textAlign: "left", color: '#202a66', marginLeft: 10, padding: "10px 0" }}> IFF Overseas</h2>
        <h2 className="header-h2" style={{ fontSize: "22px", textAlign: "center", width: '80%' }}> {arrangement.wg_name}</h2>
        <h2 className="header-h2" style={{ textAlign: "left", color: '#202a66', marginLeft: 10, padding: "10px 0" }}></h2>

        {/* <i class="fa fa-sign-out"  style={{ marginRight: 10}}></i> */}
      </div>


      <div className="mainBlock" style={{ margin: "0px 10px ", width: "98%" }}>
        {/* <div className="wg_block1">
          <div className='wg_block' style={{ width: "45%", minWidth: "200px" }}>
          <img style={{ width: "50px", marginRight: 10 }}
            src={require("../Assets/new_logo.png")}
            alt="logo"
          />
          <h2 className="header-h2" style={{ textAlign: "center" }}> IFF Overseas</h2>
        </div>
          <h2 className="header-h2" style={{ fontSize: "22px", textAlign: "center", width: '100%' }}> {arrangement.wg_name}</h2>
        </div> */}

        <div className='inline' style={{ justifyContent: "space-between" }}>

          {Object.keys(arrangement).length === 0 ?
            <div className='col-1'
              style={{
                display: "inline-flex",
                flexDirection: "row",
                justifyContent: "space-evenly",
                opacity: 1,
                transition: "opacity 0.5s ease",
              }}
            >
              {Array.from({ length: 4 }).map((_, index) => (
                <div key={index} style={{ width: "70px", height: "70px" }}>
                  <Skeleton count={1} />
                </div>
              ))}
            </div>
            :
            ((chunkedArrangement.length < 7)
              ?
              <div  style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(2, 1fr)',
                gap: '15px',
                // height: "90vh",
                backgroundColor: "white", 
                width: '75%',
                marginTop: '5px',
                backgroundColor: 'white',
                padding: '10px',
              }}>
                {chunkedArrangement.map((item, index) => (
                  <div key={index} style={{ margin: "10px 0px", backgroundColor:"aliceblue", padding: "20px", borderRadius:20, boxShadow: 'rgba(0, 0, 0, 0.1) 0px 2px 5px', }} >
                    <h6 style={{ margin: "5px 0", color: "black", fontWeight: "600", fontSize: 20, textAlign: "center" }}>{item.part_name ?? "Leather bag"}</h6>
                    <div style={{ display: "flex", flexDirection: "row", alignItems: "center", }}>
                      <GiSewingMachine size={80} color={item.color} style={{ backgroundColor: "white", padding: 5, borderRadius: 20, border: "1px solid black" }} />
                      <h6 style={{ marginLeft: "10px", display: "flex", flexDirection: "column" }}>
                        <span style={{ fontWeight: "700", fontSize: 17, color: "black" }}>{item.sensor_name}</span>
                        <span style={{ color: "#003366", fontSize: 16, marginLeft: "5px" }}> Count : {item.projected_product_count}</span>
                        <span style={{ color: "#003366", fontSize: 16, marginLeft: "5px" }}>{item.eff.toFixed(0)}%</span>
                      </h6>
                    </div>
                  </div>
                ))}
              </div>
              :
              <div className='col-1' style={{
                display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "10px", justifyContent: "flex-start",
                transition: "opacity 0.5s ease",
              }}>
                {chunkedArrangement.map((column, colIndex) => (
                  <div key={colIndex} style={{ display: "flex", flexDirection: "column" }}>
                    {column.map((item, index) => (
                      <div key={index} style={{ padding: "5px 0", alignItems: 'flex-start', marginLeft: 20 }}>
                        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", }}>
                          <GiSewingMachine size={25} color={item.color} />
                          <h6 style={{ marginLeft: "10px" }}>
                            <span style={{ fontWeight: "700", fontSize: 13, color: "black" }}>{item.sensor_name} / </span>
                            <span style={{ color: "#003366", fontSize: 14, marginLeft: "5px" }}>{item.eff.toFixed(0)}%</span>
                            <span style={{ color: "#003366", fontSize: 13, marginLeft: "5px" }}> / {item.projected_product_count}</span>
                          </h6>
                        </div>
                        <h6 style={{ margin: "2px 0", color: "gray", fontWeight: "600", fontSize: 14 }}>{item.part_name ?? "Leather bag"}</h6>
                      </div>
                    ))}
                  </div>
                ))}
              </div>)
          }

          {Object.keys(arrangement).length === 0 ?
            <div className='col-2'>

              <h5 className='col2-h5'>job in production</h5>
              <h4 className='col2-h4'><Skeleton count={1} /></h4>
              <br></br>

              <h5 className='col2-h5'>Today's goal</h5>
              <h4 className='col2-h4'><Skeleton count={1} /></h4>
              <br></br>

              <div className="efficiency-container">
                <div className="efficiency-item highest">
                  <h5>Highest Efficiency</h5>
                  <h4><Skeleton count={1} /></h4>
                  <h4><Skeleton count={1} /></h4>
                </div>
                <div className="vertical-line"></div>
                <div className="efficiency-item lowest">
                  <h5>Lowest Efficiency</h5>
                  <h4><Skeleton count={1} /></h4>
                  <h4><Skeleton count={1} /></h4>
                </div>
              </div>
              <br></br>

              <h5 className='col2-h5'>Machine on hold</h5>
              <h4 className='col2-h4'><Skeleton count={1} /></h4>
              <br></br>

              <h5 className='col2-h5'>collected Products</h5>
              <h4 className='col2-h4'><Skeleton count={1} /></h4>
              <br></br>


            </div>
            :
            <div className='col-2'>

              <div
                style={{ position: "fixed", right: "10px", top: "5px" }}
                onClick={() => onTimerComplete()}
              >
                <CountdownCircleTimer
                  isPlaying
                  size={40}
                  strokeWidth={4}
                  duration={45}
                  onComplete={() => {
                    onTimerComplete()
                    return { shouldRepeat: true, delay: 0 }
                  }}
                  colors={['#004777', '#F7B801', '#A30000', '#A30000']}
                  colorsTime={[45, 30, 10, 0]}
                >
                  {/* {({ remainingTime }) => remainingTime} */}
                </CountdownCircleTimer>
              </div>


              <h5 className='col2-h5'>job in production</h5>
              <h4 className='col2-h4'>{arrangement.current_job_working}</h4>
              <br></br>

              <h5 className='col2-h5'>Today's goal</h5>
              <h4 className='col2-h4'>{arrangement.line_target}</h4>
              <br></br>

              {/* <h5 className='col2-h5'>Product count produced (till date)</h5>
          <h4 className='col2-h4'>{arrangement.product_count}</h4>
          <br></br> */}

              <div className="efficiency-container">
                <div className="efficiency-item highest">
                  <h5>Highest %</h5>
                  <h4>{arrangement.efficency.length ? arrangement.efficency[0].sensor_name : ""}</h4>
                  <h4>{arrangement.efficency.length ? arrangement.efficency[0].eff.toFixed(0) : "0"}%</h4>
                </div>
                <div className="vertical-line"></div>
                <div className="efficiency-item lowest">
                  <h5>Lowest %</h5>
                  <h4>{arrangement.efficency.length ? arrangement.efficency[1].sensor_name : ""}</h4>
                  <h4>{arrangement.efficency.length ? arrangement.efficency[1].eff.toFixed(0) : "0"}%</h4>
                </div>
              </div>
              <br></br>


              <h5 className='col2-h5'>Machine on hold</h5>
              <h4 className='col2-h4'>{arrangement.machine_halt_count}</h4>
              <br></br>

              <h5 className='col2-h5'>collected Products</h5>
              <h4 className='col2-h4'>{arrangement.collect_from_ws}</h4>
              <br></br>

              <div className="disclaimer-container">

                <div className="disclaimer-item">
                  <GiSewingMachine size={15} color={"green"} />
                  <h6>Machines on </h6>
                </div>
                <div className="disclaimer-item">
                  <GiSewingMachine size={15} color={"orange"} />
                  <h6>Machines halt</h6>
                </div>
                <div className="disclaimer-item">
                  <GiSewingMachine size={15} color={"yellow"} />
                  <h6>Underperforming Machines</h6>
                </div>
                <div className="disclaimer-item">
                  <GiSewingMachine size={15} color={"red"} />
                  <h6>Machines off</h6>
                </div>
              </div>


            </div>
          }

        </div>
        <div className='powered'>
          <i class="fa fa-copyright" style={{ fontSize: 10, paddingRight: 4 }}></i>
          <p>Powered by</p>
          <img style={{ width: "20px", margin: "0  0 0 5px" }}
            src={require("../Assets/new_logo.png")}
            alt="logo"
          />
          <p style={{ margin: 0, fontWeight: 600 }}>SuperManager</p>
        </div>
      </div>
    </div >
  )
}

export default Wg_Dashboard